import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavItem } from 'reactstrap';

import getPermissions from '../permissions';

export const DisconnectedPdxNavItem = ({
  children,
  hasPermission,
  style
}) => (
  hasPermission && <NavItem style={style}>{children}</NavItem>
);

DisconnectedPdxNavItem.defaultProps = {
  style: {},
  hasPermission: true
};

DisconnectedPdxNavItem.propTypes = {
  children: PropTypes.node.isRequired,
  hasPermission: PropTypes.bool,
  style: PropTypes.objectOf(PropTypes.string)
};

const mapStateToProps = (state, ownProps) => ({
  hasPermission: ownProps.id ? getPermissions(state)[ownProps.id] : false,
});

export default connect(mapStateToProps)(DisconnectedPdxNavItem);
